import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'

import * as state from '../../../../../state'

@ngCore.Component({
  imports: [ngRouter.RouterOutlet],
  providers: [
    // Keep route-bound state in the boundary component injector. Angular
    // recreates this injector with the component, which lets destroyed app
    // state be instantiated fresh when the user leaves an app and later
    // re-enters it.
    state.routeBound.Registry,
    state.routeBound.scenario.Context.provide(),
    state.routeBound.Registry.provideDestroyable(
      state.routeBound.scenarios.Feature,
    ),
    ...state.dms.provideEntityCollections(),
    ...state.integrations.provideAppEntityCollections(),
    ...state.mosaic.provideEntityCollections(),
    ...state.rate.provideEntityCollections(),
    ...state.space.provideEntityCollections(),
  ],
  selector: 'atn-app-route-boundary',
  standalone: true,
  templateUrl: './component.html',
})
export class Component {}
